'use client'

import { cn } from '@mentora/ui-components'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export function CourseTabs({ courseId }: { courseId: string }) {
  const t = useTranslations('courseTabs')
  const pathname = usePathname()
  const base = `/courses/${courseId}`

  const tabs = [
    { href: base, label: t('editor') },
    { href: `${base}/stats`, label: t('stats') },
    { href: `${base}/enrollments`, label: t('enrollments') },
    { href: `${base}/vip`, label: t('vip') },
  ] as const

  return (
    <div className="inline-flex h-9 w-fit items-center justify-center rounded-md bg-[var(--color-muted)] p-1 text-muted-foreground">
      {tabs.map((tab) => {
        const active = tab.href === base
          ? pathname === base
          : pathname?.startsWith(tab.href)
        return (
          <Link
            key={tab.href}
            href={tab.href}
            className={cn(
              'inline-flex items-center justify-center gap-1.5 rounded-sm px-3 py-1 text-sm font-medium whitespace-nowrap ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              active && 'bg-background text-foreground shadow-sm',
            )}
          >
            {tab.label}
          </Link>
        )
      })}
    </div>
  )
}
